/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { sessionTabsAll, sessionTabs2 } from './utils/list_data';
import { sessionsAPI } from 'src/api/modules/sessions';
import { filesAPI } from 'src/api/modules/files';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import PageLayout from 'src/common/components/PageLayout';
import AntTabs from 'src/common/components/AntTabs';
import notice from 'src/common/components/Notice';
import DetailTabs from './DetailTabs';
import FormSession from './FormSession';

const Session = () => {
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const [session, setSession] = useState();
	const [tabValue, setTabValue] = useState(1);
	const [nameOrgan, setNameOrgan] = useState('');
	const [migratedSessionPer, setMSP] = useState();
	const [currentFile, setCurrentFile] = useState();
	const [permitEdit, setPermitEdit] = useState(false);
	const usersCanEdit = [
		'ADMINISTRADOR GENERAL',
		'RESPONSABLE DE ORGANO COLEGIADO',
		'SISTEMA',
		'RESPONSABLE DE NEGOCIO',
	];

	const { id } = useParams();
	useEffect(() => {
		setPermitEdit(usersCanEdit.includes(systemLevelRole));
		getSession(id);
		getFiles();
	}, [id]);

	const getSession = (idSession) => {
		sessionsAPI
			.getBySession(idSession)
			.then((response) => {
				const fecha = response.fecha.split('-');

				response.fhora = new Date(
					fecha[2] + '-' + fecha[1] + '-' + fecha[0] + 'T' + response.hora
				);
				response.nameOrgan =
					response.organoColegiado.nombre !== undefined
						? response.organoColegiado.nombre
						: '';

				setSession(response);
				validateOrgan(response.nameOrgan);
				if (response.migrado === true) setMSP(false);
			})
			.catch(() => notice('Ocurrio un error'));
	};

	const validateOrgan = (organ) => {
		if (
			//Grupo1
			organ.toUpperCase() === 'CONSEJO DE ADMINISTRACIÓN'
		)
			setNameOrgan('G1');
		else if (
			//Grupo2
			organ.toUpperCase() === 'ASAMBLEA GENERAL' ||
			organ.toUpperCase() === 'COMITÉ DE TRANSPARENCIA'
		)
			setNameOrgan('G2');
		else if (
			//Grupo3
			organ.toUpperCase() === 'COMITÉ DE AUDITORÍA' ||
			organ.toUpperCase() === 'COMISIÓN DE VIGILANCIA'
		)
			setNameOrgan('G3');
	};

	const handleChangeTab = (newValue) => {
		setTabValue(newValue);
	};

	const getFiles = () => {
		filesAPI
			.get('SESION', id, false, 'C')
			.then((response) => {
				// response = response.filter((e) => {
				// 	return e.tipo === 'A' && e.ruta.charAt(0) === 'C';
				// });

				const file = {
					idEntidad: id,
					tipo: 'A',
					entidad: 'SESION',
					ruta: 'Convocatoria/' + id + '/',
					title: 'Convocatoria',
					nombre:
						response.length > 0 ? response[response.length - 1].nombre : '',
				};

				setCurrentFile(file);
			})
			.catch((e) => {
				notice('Ocurrio un error', 'error');
			});
	};

	return (
		<PageLayout>
			<FormSession isNew={false} />
			{session !== undefined && (
				<Grid container spacing={3}>
					<Grid item xs={12} lg={12}>
						{currentFile !== undefined && (
							<>
								<AntTabs
									value={tabValue}
									options={
										permitEdit === false && currentFile.nombre === ''
											? sessionTabs2
											: sessionTabsAll
									}
									onChange={handleChangeTab}
								/>
								<DetailTabs
									tab={tabValue}
									session={session}
									user={user}
									canEdit={permitEdit}
									valOrgan={nameOrgan}
									currentFile={currentFile}
									migratedSessionPer={migratedSessionPer}
								/>
							</>
						)}
					</Grid>
				</Grid>
			)}
		</PageLayout>
	);
};

export default Session;
